import { Avatar, Input, Layout } from 'antd';
import styled from 'styled-components';

const { Header } = Layout;

export const StyledHeader = styled(Header)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const StyledLogo = styled.div`
  cursor: pointer;
  width: 120px;
  min-width: 120px;
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  margin-inline-end: 24px;
`;

export const StyledSearchInput = styled(Input)`
  width: 400px;
`;

export const StyledActionsContainer = styled('div')`
  display: flex;
  gap: 20px;
  align-items: center;

  .ant-btn {
    cursor: pointer;
  }
`;

export const StyledAvatar = styled(Avatar)`
  background-color: #c0c1e7;
  color: #070719;
  margin-right: 10px;
  cursor: pointer;
`;
